module.exports = __webpack_public_path__ + "static/media/Egypt.ce56bed0.png";